import { useEffect } from 'react';
import { Outlet, useNavigate, NavLink } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/Button';
import { cn } from '@/lib/utils';
import { LayoutDashboard, Building2, Users, CreditCard, Settings, LogOut, FileText } from 'lucide-react';
import { BrandLogo } from '@/components/branding/BrandLogo';

const navItems = [
  { to: '/owner/dashboard', label: 'Inicio', icon: LayoutDashboard },
  { to: '/owner/companies', label: 'Empresas', icon: Building2 },
  { to: '/owner/users', label: 'Usuarios', icon: Users },
  { to: '/owner/billing', label: 'Facturación', icon: CreditCard },
  { to: '/owner/audit', label: 'Auditoría', icon: FileText },
  { to: '/owner/settings', label: 'Configuración', icon: Settings },
];

export function OwnerLayout() {
  const { appUser, signOut } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (appUser && appUser.role !== 'owner') {
      navigate('/app/dashboard', { replace: true });
    }
  }, [appUser, navigate]);

  if (appUser?.role !== 'owner') {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-muted-foreground">Redirigiendo...</div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-muted/30">
      <aside className="flex w-56 flex-col border-r bg-card">
        <div className="flex h-14 items-center gap-2 border-b px-2 font-semibold">
          <div className="flex shrink-0 items-center py-2 pr-0" style={{ paddingLeft: 8 }}>
            <BrandLogo variant="isotipo" size={32} alt="PsyTalent" />
          </div>
          <span className="truncate">PsyTalent · Owner</span>
        </div>
        <nav className="flex flex-1 flex-col gap-1 p-2">
          {navItems.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-2 rounded-md px-3 py-2 text-sm transition-colors',
                  isActive ? 'bg-primary text-primary-foreground' : 'hover:bg-muted'
                )
              }
            >
              <Icon className="h-4 w-4" />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t p-2">
          <div className="truncate px-3 py-2 text-xs text-muted-foreground">
            {appUser?.displayName || appUser?.email} (owner)
          </div>
          <Button variant="ghost" size="sm" className="w-full justify-start gap-2" onClick={() => signOut()}>
            <LogOut className="h-4 w-4" />
            Salir
          </Button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto p-6">
        <Outlet />
      </main>
    </div>
  );
}
